var map = {
	"./cookie": [
		600,
		9,
		600
	],
	"./cookie.ts": [
		600,
		9,
		600
	],
	"./faqheight": [
		112,
		9,
		112
	],
	"./faqheight.ts": [
		112,
		9,
		112
	],
	"./icons": [
		864,
		9,
		864
	],
	"./icons.ts": [
		864,
		9,
		864
	],
	"./index.d": [
		847,
		7,
		847
	],
	"./index.d.ts": [
		847,
		7,
		847
	],
	"./lib/Loader": [
		396,
		9
	],
	"./lib/Loader.ts": [
		396,
		9
	],
	"./main": [
		264,
		9
	],
	"./main.ts": [
		264,
		9
	],
	"./menu": [
		964,
		9,
		964
	],
	"./menu.ts": [
		964,
		9,
		964
	],
	"./navbar": [
		652,
		9,
		652
	],
	"./navbar.ts": [
		652,
		9,
		652
	],
	"./newfaq": [
		316,
		9,
		968,
		380,
		316
	],
	"./newfaq.ts": [
		316,
		9,
		968,
		380,
		316
	],
	"./numbers": [
		604,
		9,
		520,
		604
	],
	"./numbers.ts": [
		604,
		9,
		520,
		604
	],
	"./scroll": [
		284,
		9,
		284
	],
	"./scroll.ts": [
		284,
		9,
		284
	],
	"./searchbar": [
		244,
		9,
		244
	],
	"./searchbar.ts": [
		244,
		9,
		244
	],
	"./slider": [
		644,
		9,
		392,
		644
	],
	"./slider.ts": [
		644,
		9,
		392,
		644
	],
	"./svelte/FaqArticle": [
		180,
		9,
		968,
		180
	],
	"./svelte/FaqArticle.svelte": [
		180,
		9,
		968,
		180
	],
	"./svelte/NewFaq": [
		380,
		9,
		968,
		380
	],
	"./svelte/NewFaq.svelte": [
		380,
		9,
		968,
		380
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 668;
module.exports = webpackAsyncContext;